import { render, staticRenderFns } from "./EqumentDetail.vue?vue&type=template&id=5defdd3d&scoped=true&"
import script from "./EqumentDetail.vue?vue&type=script&lang=js&"
export * from "./EqumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./EqumentDetail.vue?vue&type=style&index=0&id=5defdd3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5defdd3d",
  null
  
)

export default component.exports